import {ErrorHandler} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {MessageService} from "./message.service";
import {AlertEnum} from "../../models/Enums/AlertEnum";

export class ClientErrorHandlerService implements ErrorHandler {
	constructor(private readonly messageService: MessageService) {}

	handleError(error: Error) {
		if (error?.toString().includes("Error: NG0911: ")) {
			// this error is thrown when the User changes list while this component is still loading
			// and can be ignored
			console.debug("Error: NG0911");
			return;
		}

		if (error) {
			console.error(error);
			if (!environment.production) {
				this.messageService.add(this.createErrorMessage(error), AlertEnum.DANGER);
			}
		}
	}

	createErrorMessage(error: Error): string {
		let errorString: string = "" + error;

		const endOfFirstLine = errorString.indexOf("\n");
		if (endOfFirstLine > 0) {
			errorString = errorString.substring(0, endOfFirstLine);
		}
		return `
<h2>Runtime error was caught and printed to console. Please fix the issue before merging to master!</h2>
<p>${errorString} ...</p>
<small>This message is only displayed during development! More info in console (F12 in chrome)</small>
`;
	}
}
